import { render, staticRenderFns } from "./Workbook.vue?vue&type=template&id=62cc2fb6&scoped=true"
import script from "./Workbook.vue?vue&type=script&lang=js"
export * from "./Workbook.vue?vue&type=script&lang=js"
import style0 from "./Workbook.vue?vue&type=style&index=0&id=62cc2fb6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62cc2fb6",
  null
  
)

export default component.exports